import React from 'react';

import {
  BestDay,
  CDF,
  Discover,
  InField,
  InRobot,
  Maintain,
  Remote,
  Atlas,
} from './logos';
import type { ProductLogoProps } from './types';

/**
 * ProductLogo
 * =============================================================================
 * Shows the Cognite logo with, or without type
 *
 * [Open docs »](https://cognitedata.github.io/cogs.js/?path=/docs/assets-logo--base)
 *
 * -----------------------------------------------------------------------------
 * Examples
 * -----------------------------------------------------------------------------
 * ```
 * <ProductLogo />
 * <ProductLogo type="Discover" />
 * <ProductLogo type="InField" inverted />
 * <ProductLogo type="InRobot" inverted size="80px" />
 * ```
 *
 * -----------------------------------------------------------------------------
 * Properties
 * -----------------------------------------------------------------------------
 * @param size    - The size of the logo as css value.
 * @param type    - Which logo to show.
 *
 * [Read the full documentation »](https://cognitedata.github.io/cogs.js/?path=/docs/assets-logo--base)
 */
export const ProductLogo: React.FC<
  React.PropsWithChildren<ProductLogoProps>
> = ({ type, ...otherProps }) => {
  switch (type) {
    case 'BestDay':
      return <BestDay {...otherProps} />;
    case 'CDF':
      return <CDF {...otherProps} />;
    case 'Discover':
      return <Discover {...otherProps} />;
    case 'InField':
      return <InField {...otherProps} />;
    case 'InRobot':
      return <InRobot {...otherProps} />;
    case 'Maintain':
      return <Maintain {...otherProps} />;
    case 'Remote':
      return <Remote {...otherProps} />;
    case 'Atlas':
      return <Atlas {...otherProps} />;

    default:
      return <CDF {...otherProps} />;
  }
};
